import React from "react";
import { useIntl } from "react-intl";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  th: {
    padding: 7,
    fontSize: 10,
    color: theme.palette.primary.main,
    fontWeight: 600,
    textTransform: "uppercase",
    verticalAlign: "top",
    background: "#efefef",
  },
}));

const SupplierHeader = () => {
  const classes = useStyles();
  const intl = useIntl();

  const header = [
    {
      name: "email",
      label: intl.formatMessage({
        id: "orderHistory.email",
      }),
    },
    // { name: "date", label: "Date" },
    { name: "remove", label: "" },
  ];
  return (
    <TableHead>
      <TableRow>
        {header.map(head => {
          return <TableCell className={classes.th}>{head.label}</TableCell>;
        })}
      </TableRow>
    </TableHead>
  );
};

export default SupplierHeader;
